import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";

const Cms = () => {
  const [currentUrl, setcurrentUrl] = useState("");
  const uid = uuidv4();

  useEffect(() => {
    getIframeUrl();
  }, []);
  const getIframeUrl = async () => {
    const ticketcrm = JSON.parse(localStorage.getItem("ticketcrm"));
    if (ticketcrm) {
      setcurrentUrl(ticketcrm.data);
      document.cookie = `uid=${ticketcrm.uid}`;
      const iframe = document.getElementById("CMS");
      if (iframe) {
        iframe.contentWindow.postMessage({ cookieData: document.cookie }, "*");
      }
    }
  };

  return (
    <div
      className="d-flex justify-content-center h-100"
      style={{ width: "100%", height: "100%" }}
    >
      <iframe
        id="CMS"
        src={currentUrl}
        style={{ width: "100%", height: "100%" }}
      ></iframe>
    </div>
  );
};

export default Cms;
